import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchPriceAdjustment } from '../../actions/purchaseOrders_actions';
import PriceAdjustmentReport from '../../components/Purchase/priceAdjustment';

let priceAdjustmentReport = reduxForm({
  form: 'priceAdjustmentReport',
})(PriceAdjustmentReport);

const selector = formValueSelector('priceAdjustmentReport');

function mapStateToProps(state) {
    return {
      priceAdjustmentIsLoading: state.purchaseOrders.priceAdjustmentIsLoading,
      priceAdjustment: state.purchaseOrders.priceAdjustment,
      priceAdjustmentError: state.purchaseOrders.priceAdjustmentError,
    };
}

export default connect(mapStateToProps, { fetchPriceAdjustment })(priceAdjustmentReport);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/priceAdjustment.jsx